<app-base-notification [base]="base">
  <div [innerHTML]="'notifications.contract-prolong-order-unpaid.text' | translate"></div>

  <a class="link" [href]="params.processing_url" (click)="processLinks($event)">{{ 'notifications.contract-prolong-order-unpaid.action' | translate }}</a>
</app-base-notification>
